import { useCallback } from 'react';
import { log } from 'log';
import { prop } from 'ramda';

import { checkAccountBusinessPhase } from 'js/app/hooks/user/server';
import { useAppSelector } from 'js/store/hooks';

export const useCheckAccountBusinessPhase = ({ handlerFoundUser, handlerNotFoundUser }) => {
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async ({
        businessPhase,
        field,
        descriptionName,
        email,
        userName
    }) => {
        try {
            const response = await checkAccountBusinessPhase({
                field,
                email,
                userName,
                casinoName,
                businessPhase,
                descriptionName
            });

            if (!response.data.resultCount) {
                handlerNotFoundUser();

                return;
            }

            handlerFoundUser(email);
        } catch (error) {
            log('error', error);
        }
    }, [casinoName, handlerFoundUser, handlerNotFoundUser]);
};
